import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import domainReducer, {setDomainMarketCode} from './domainSlice';
import {getMarketCode, DomainMarketCode} from './domainConstants';

export default class DomainInitializableModule implements IInitializableModule {
  protected name: string = 'Domain module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
    //No action taken by default
  }

  public StartModule(context: IEpiserverContext): void {
    let MarketCode: string = DomainMarketCode.CELLCOM;

    if (typeof window !== 'undefined') {
      const windowMarketCode = (window as any).__DOMAIN_MARKET_CODE__;
      const sessionMarketCode = sessionStorage.getItem('domainMarketCode');

      if (sessionMarketCode) {
        MarketCode = sessionMarketCode;
      } else if (windowMarketCode) {
        MarketCode = windowMarketCode;
      } else {
        MarketCode = getMarketCode();
      }

      (window as any).__DOMAIN_MARKET_CODE__ = MarketCode;
      sessionStorage.setItem('domainMarketCode', MarketCode);
    }

    if (typeof document !== 'undefined' ) {
      document.documentElement.setAttribute('data-market', MarketCode);
      this.applyFavicon(MarketCode);
    }

    // Dispatch MarketCode to Redux store
    context.dispatch(setDomainMarketCode(MarketCode));
  }

  private applyFavicon(marketCode: string): void {
    const hostname = (
      (typeof window !== 'undefined' && window.location?.hostname) ||
      ''
    ).toLowerCase();
    const isKnownDomain = hostname.includes('golan') || hostname.includes('cellcom');
    if (!isKnownDomain) {
      return;
    }

    const faviconHref =
      marketCode === DomainMarketCode.GOLAN ? '/Spa/favicon-gln.ico' : '/Spa/favicon.ico';
    const link =
      (document.querySelector("link[rel*='icon']") as HTMLLinkElement) ||
      document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    if (link.getAttribute('href') !== faviconHref) {
      link.href = faviconHref;
    }
    if (!link.parentNode) {
      document.head.appendChild(link);
    }
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'domain',
      reducer: domainReducer,
    };
  }
}
